import { Component } from '@angular/core';
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry,
} from 'ngx-file-drop';
import { BannerService } from 'src/app/shared/services/banner.service';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import {
  addItemtoMyPurchase
} from 'src/app/core/store/form.actions';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import {
  DropDownOptions,
  IItemToRequest,
  MyPurchaseForm,
  StoreDropdowns,
  UserInformation,
} from 'src/app/shared/models/app-models';


import { Store } from '@ngrx/store';
@Component({
  selector: 'app-item-upload-template',
  templateUrl: './item-upload-template.component.html',
  styleUrls: ['./item-upload-template.component.scss']
})

export class ItemUploadTemplateComponent {
  showErrorMessage: boolean = false;
  files: NgxFileDropEntry[] = [];

  isReadOnly: boolean = true;
  form!: MyPurchaseForm;
  fileNameErrorMsg: string =
    'The following special characters are not allowed for filename: “~ # % * , { }  : < > ? / + | & ” . ".';
  errorMsg: string = '';
  filePageSize: number = 5;
  fileCurrentPage = 0;
  fileName: string = '';
  fileData: string = '';
  error: string = '';
  success: SafeHtml = '';
  itemList: IItemToRequest[] = [];
  dpOptions!: StoreDropdowns;
  destroy$: Subject<boolean> = new Subject<boolean>();
  uploadingInProgress: boolean = false;
  constructor(
    private bannerService: BannerService,
    private store: Store<{ form: MyPurchaseForm; dp: StoreDropdowns, user: UserInformation }>,
    private backendService: BackendApiService,
    private formTransformer: FormTransformerPipe,
    private sanitizer: DomSanitizer
  ) {
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.dpOptions = dp;
      });
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        this.form = form;
        console.log('form object', this.form)

      });
  }
  dropped(files: NgxFileDropEntry[]) {
    this.showErrorMessage = false;
    this.files = files;
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.processFile(file);
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(
          'this is presumed directory: ',
          droppedFile.relativePath,
          fileEntry
        );
        // dont allow directories
        // this.errorMsg = this.fileUploadErrorMsg;
        // this.showErrorMessage = true;
      }
    }
  }

  isValidFileSize(file: File) {
    if (file?.size > 50 * 1024 * 1024) return false; //dont allow more than 50mb. uncomment when the file size payload has increased.
    return true;
  }

  isValidFormat(file: File) {
    const allowedExts = ['xlsx'];
    const fileName = file?.name.split('.');
    const ext = fileName[fileName.length - 1];

    if (!allowedExts.includes(ext.toLowerCase())) {
      return false;
    }
    return true;

  }
  private convertToBase64(file: File): Promise<any> {
    const reader = new FileReader();
    const future = new Promise((resolve, reject) => {
      reader.addEventListener(
        'load',
        function () {
          resolve(reader.result);
        },
        false
      );
      reader.addEventListener(
        'error',
        function (event) {
          reject(event);
        },
        false
      );

      reader.readAsDataURL(file);
    });
    return future;
  }

  async processFile(fileToProcess: File) {
    this.showErrorMessage = false;
    try {
      if (!this.isValidFormat(fileToProcess)) {
        this.showErrorMessage = true;
        this.errorMsg = 'Invalid File type. Please check and try again.';
        return;
      }
      if (!this.isValidFileSize(fileToProcess)) {
        this.showErrorMessage = true;
        this.errorMsg = 'File Size Exceeded the maximum limit of 50mb.';
        return;
      }
      let base64file = await this.convertToBase64(fileToProcess);
      const fileName = fileToProcess.name.split(/\.(?=[^\.]+$)/);
      const ext = fileName[fileName.length - 1];
      let checkSpecialChars = this.restrictSpecialChars(fileName[0]);
      if (checkSpecialChars) {
        this.showErrorMessage = true;
        this.errorMsg = this.fileNameErrorMsg;
        return;
      }
      this.errorMsg = '';
      this.fileName = fileToProcess.name;
      this.fileData = base64file;
    } catch (err) { }
  }

  addFile(file: any) {
    console.log("file", file)
    this.fileName = file.fileToStore.FileName;
  }

  removeFile() {
    this.fileName = '';
    this.fileData = '';
  }

  restrictSpecialChars(fileName: string) {
    var specialChars = /[~#%*,{}\:<>?/+|&”]/;
    console.log('regex: ', specialChars);
    return specialChars.test(fileName);
  }

  async uploadFile() {
    this.uploadingInProgress = true;
    try {
      this.error = '';
      this.success = '';
      let IsContract = false;
      this.showErrorMessage = false;
      if (this.fileData !== '') {

        if (this.form.PurchaseTypeId === 5 || this.form.PurchaseTypeId == 6) {
          IsContract = true
        }
        let apiResponse = await lastValueFrom(this.backendService.validateItemAttachment(this.fileData, IsContract));
        if (Array.isArray(apiResponse) && apiResponse.length > 0) {
          let successMessage = `Upload successful: <b>${this.fileName}</b>\n`;
          let i = this.form.ItemList.length > 0 ? this.form.ItemList.length : 0;
          apiResponse.forEach((item: { data: Object, messages: string[] }) => {
            i++;
            let itemToReturn: IItemToRequest = this.formTransformer.transformAddItem(item.data, i, this.dpOptions, this.form.PurchaseTypeId)
            this.store.dispatch(addItemtoMyPurchase({ form: itemToReturn }));
            for (const message of item.messages) {
            successMessage += `${message}\n`
            }
          });
          if (apiResponse.length === 1)
            successMessage += `<b>${apiResponse.length} Item</b> inserted successfully\n`
          else if (apiResponse.length >= 1)
            successMessage += `<b>${apiResponse.length} Items</b> inserted successfully\n`
          this.fileName = '';
          this.fileData = '';
          this.success = this.sanitizer.bypassSecurityTrustHtml(successMessage);
          this.uploadingInProgress = false;
        }
        else if (Array.isArray(apiResponse) && apiResponse.length === 0) {
          this.showErrorMessage = true;
          this.errorMsg = 'No record was found in the file. Please upload atleast 1 record.';
          this.uploadingInProgress = false;
        }
      } else {
        this.showErrorMessage = true;
        this.errorMsg = 'No file detected. Please upload a file.';
        this.uploadingInProgress = false;
      }

    } catch (err) {
      let errorMessage = '';
      if (Array.isArray(err) && err.length > 0) {
        let hasAnyErrors = false;
        err.forEach((error: string) => {
          errorMessage += `${error}\n`;
        });
        this.error = errorMessage;
      } else {
        this.showErrorMessage = true;
        this.errorMsg = 'There was a problem uploading the file. Please try again.';
      }
      this.success = '';
      this.uploadingInProgress = false;
    }
  }

}


